function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var v = Object.defineProperty,
    P = Object.defineProperties;
var L = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var T = Object.prototype.hasOwnProperty,
    C = Object.prototype.propertyIsEnumerable;

var m = function m(t, e, r) {
  return e in t ? v(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r;
},
    c = function c(t, e) {
  for (var r in e || (e = {})) {
    T.call(e, r) && m(t, r, e[r]);
  }

  if (p) {
    var _iterator = _createForOfIteratorHelper(p(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        C.call(e, r) && m(t, r, e[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    s = function s(t, e) {
  return P(t, L(e));
};

import { makeTemplate as w, normalizeRoute as N, useRoutes as A } from "@stackflow/plugin-history-sync";
import { useMemo as h } from "react";
import k, { createContext as g, useContext as R } from "react";

var y = g({}),
    f = function f(t) {
  return k.createElement(y.Provider, {
    value: t.loaders
  }, t.children);
};

function l() {
  return R(y);
}

function x() {
  var t = l(),
      e = A();
  return h(function () {
    return {
      preload: function preload(r, o, d) {
        var a = t[r];
        if (!a) return null;
        var n = e[r],
            i = n ? w(N(n)[0]) : void 0,
            u = i == null ? void 0 : i.fill(o);
        return a({
          activityParams: o,
          activityContext: c(c({}, u ? {
            path: u
          } : null), d == null ? void 0 : d.activityContext)
        });
      }
    };
  }, [t]);
}

function b() {
  return {
    usePreloader: x
  };
}

import F from "react";

function G(t) {
  return function () {
    return {
      key: "plugin-preload",
      wrapStack: function wrapStack(_ref) {
        var e = _ref.stack;
        return F.createElement(f, {
          loaders: t.loaders
        }, e.render());
      },
      overrideInitialEvents: function overrideInitialEvents(_ref2) {
        var e = _ref2.initialEvents,
            r = _ref2.initialContext;
        return e.length === 0 ? [] : e.map(function (o) {
          if (o.name !== "Pushed") return o;
          var d = o.activityName,
              a = o.activityParams,
              n = o.activityContext,
              i = t.loaders[d];
          if (!i) return o;
          var u = i({
            activityParams: a,
            activityContext: n,
            isInitialActivity: !0,
            initialContext: r
          });
          return s(c({}, o), {
            activityContext: s(c({}, o.activityContext), {
              preloadRef: u
            })
          });
        });
      },
      onBeforePush: function onBeforePush(_ref3) {
        var e = _ref3.actionParams,
            r = _ref3.actions.overrideActionParams;
        var o = e.activityName,
            d = e.activityParams,
            a = e.activityContext,
            n = t.loaders[o];
        if (!n) return;
        var i = n({
          activityParams: d,
          activityContext: a
        });
        r(s(c({}, e), {
          activityContext: s(c({}, a), {
            preloadRef: i
          })
        }));
      },
      onBeforeReplace: function onBeforeReplace(_ref4) {
        var e = _ref4.actionParams,
            r = _ref4.actions.overrideActionParams;
        var o = e.activityName,
            d = e.activityParams,
            a = e.activityContext,
            n = t.loaders[o];
        if (!n) return;
        var i = n({
          activityParams: d,
          activityContext: a
        });
        r(s(c({}, e), {
          activityContext: s(c({}, a), {
            preloadRef: i
          })
        }));
      }
    };
  };
}

import { useActivity as M } from "@stackflow/react";

function Q() {
  var e = M().context;
  return e == null ? void 0 : e.preloadRef;
}

export { b as createPreloader, G as preloadPlugin, Q as useActivityPreloadRef, l as useLoaders, x as usePreloader };